<p>{{value}}</p>
<!-- <app-spinner [diameter]="'24'" *ngIf="loading"></app-spinner> -->
<!-- TODO: Ломает даилоговые окна -->